<div [formGroup]="form" class="container payment-form">
  <div class="row">
    <div class="col-sm-6 col-12">
      @if (allowOneTimeAch && !isCardSwipe && !isViewMode) {
      <mat-button-toggle-group
        class="payment-type-toggle"
        [value]="paymentType"
        (change)="setPaymentType($event.value)"
        aria-label="Payment type"
        style="margin-bottom: 12px"
      >
        <mat-button-toggle value="CARD"> <mat-icon>credit_card</mat-icon> Card </mat-button-toggle>
        <mat-button-toggle value="ACH"> <mat-icon>account_balance</mat-icon> ACH </mat-button-toggle>
      </mat-button-toggle-group>
      }
      @if (paymentType === 'CARD') {
      <fieldset style="min-height: 460px; padding: 16px; max-height: 460px">
        <legend>
          Payment Information <span style="font-style: italic; color: green"> - (card swipe enabled)</span>
        </legend>
        <div class="form-control-group">
          <div class="form-control" style="min-width: 280px; max-width: 100%">
            <mat-form-field appearance="outline">
              <mat-label>Card Holder Name</mat-label>
              <input matInput #cardHolderNameInput formControlName="cardHolderName" [readonly]="isViewMode" />
              <mat-error>
                @if (form.controls.cardHolderName.hasError('required')) { Card holder name is required. } @if
                (form.controls.cardHolderName.hasError('minlength')) { Name must be at least 2 characters. } @if
                (form.controls.cardHolderName.hasError('maxlength')) { Name cannot exceed 50 characters. } @if
                (form.controls.cardHolderName.hasError('pattern')) { Only letters, spaces, hyphens and apostrophes
                allowed. }
              </mat-error>
            </mat-form-field>
          </div>
        </div>

        <div class="form-control-group">
          <div class="form-control" style="min-width: 280px; max-width: 100%">
            <mat-form-field appearance="outline">
              <mat-label>Card Number</mat-label>
              <input
                matInput
                #accountInput
                formControlName="account"
                [readonly]="isViewMode"
                [hiddenInput]="hideCardNumber"
                [mask]="cardMask"
              />
              <button mat-icon-button matSuffix (click)="hideCardNumber = !hideCardNumber">
                <mat-icon *ngIf="hideCardNumber">visibility</mat-icon
                ><mat-icon *ngIf="!hideCardNumber">visibility_off</mat-icon>
              </button>
              <mat-icon matPrefix *ngIf="isCardSwipe" style="color: green" matTooltip="Swipe detected"
                >credit_card</mat-icon
              >
              <mat-icon matPrefix *ngIf="!isCardSwipe" color="primary">credit_card</mat-icon>
              <mat-error>
                @if (form.controls.account.hasError('required')) { Card number is required. } @if
                (form.controls.account.hasError('pattern')) { Invalid card number. }
                @if(form.controls.account.hasError('cardInvalid')) { Card number is invalid. }
              </mat-error>
            </mat-form-field>
          </div>
        </div>

        <div class="form-control-group" style="min-width: 280px; max-width: 100%">
          <div class="form-control" style="width: 48%">
            <mat-form-field appearance="outline">
              <mat-label>Exp. Date</mat-label>
              <input
                matInput
                #expirationDateInput
                placeholder="MM YY"
                formControlName="expirationDate"
                [readonly]="isViewMode"
                mask="00 00"
              />
              <mat-error>
                @if (form.controls.expirationDate.hasError('required')) { Expiration date is required. } @if
                (form.controls.expirationDate.hasError('pattern')) { Invalid format (MM YY). } @if
                (form.controls.expirationDate.hasError('expirationDateInvalid')) { Card has expired. } @if
                (form.controls.expirationDate.hasError('expirationDateTooFar')) { Date too far in future. }
              </mat-error>
            </mat-form-field>
          </div>
          <div class="form-control" style="width: 48%">
            <mat-form-field appearance="outline">
              <mat-label>CVV Code{{ requireCVV ? '' : ' (optional)' }}</mat-label>
              <input
                matInput
                #cvvInput
                formControlName="cvv"
                [readonly]="isViewMode"
                [mask]="cvvMask"
                [hiddenInput]="hideCvv"
              />
              <button mat-icon-button matSuffix (click)="hideCvv = !hideCvv">
                <mat-icon *ngIf="hideCvv">visibility</mat-icon><mat-icon *ngIf="!hideCvv">visibility_off</mat-icon>
              </button>
              <mat-error>
                @if (requireCVV && form.controls.cvv.hasError('required')) { CVV is required. } @if
                (form.controls.cvv.hasError('cvvInvalid')) { CVV verification failed. }
              </mat-error>
            </mat-form-field>
          </div>
        </div>

        <div class="form-control-group" style="min-width: 280px; max-width: 100%">
          <div class="form-control" style="width: 52%">
            <mat-form-field appearance="outline">
              <mat-label>Street Address</mat-label>
              <input
                matInput
                #addressInput
                formControlName="streetAddress"
                [readonly]="isViewMode || form.controls.skipAVS.value"
              />
              <mat-error>
                @if (form.controls.streetAddress.hasError('required')) { Street address is required. } @else if
                (form.controls.streetAddress.hasError('maxlength')) { Address cannot exceed 50 characters. } @else if
                (form.controls.streetAddress.hasError('streetInvalid')) { Address verification failed. }
              </mat-error>
            </mat-form-field>
          </div>
          <div class="form-control" style="width: 22%">
            <mat-form-field appearance="outline">
              <mat-label>Zip Code</mat-label>
              <input
                matInput
                #zipInput
                formControlName="zipCode"
                [readonly]="isViewMode || (form.controls.skipAVS.value && !isRetailProfile)"
                [mask]="zipMask"
              />
              <mat-error>
                @if (form.controls.zipCode.hasError('required')) { Zip code is required. }
                @else if (form.controls.zipCode.hasError('pattern')) { Invalid Zip Code format. }
                @else if (form.controls.zipCode.hasError('minlength')) { Zip code is invalid. }
                @else if (form.controls.zipCode.hasError('maxlength')) { Zip code is invalid. }
                @else if (form.controls.zipCode.hasError('zipInvalid')) { Zip code verification failed. }
              </mat-error>
            </mat-form-field>
          </div>
          @if(this.enforceAVSMatch == false) {
          <div class="form-control" style="width: 26%; align-self: center">
            <mat-slide-toggle [formControl]="form.controls.skipAVS" color="primary" style="font-size: 12px">
              @if (isRetailProfile) { Skip Street Address } @else { Skip Address verification }
            </mat-slide-toggle>
          </div>
          }
        </div>
        @if(this.enforceAVSMatch == false && form.controls.skipAVS.value && form.controls.saveToken.value) {
        <div class="form-control" style="color: #f44336; font-size: 12px; padding-top: 4px; margin-top: -12px">
          Unable to save credentials without address verification.
        </div>
        }

        <div class="form-control-group">
          @if (isVerificationPending) {
          <div style="display: flex; align-items: center; gap: 8px; color: #0d6efd; font-size: 13px; padding: 4px 0">
            <mat-icon style="font-size: 18px; width: 18px; height: 18px; animation: spin 1s linear infinite"
              >sync</mat-icon
            >
            Verifying card...
          </div>
          } @else {
          <span *ngIf="isCardValidated" style="color: green">{{ invalidMessage }}</span>
          <mat-error>
            <span *ngIf="!isCardValidated">{{ invalidMessage }}</span>
          </mat-error>
          @if (showVerifyCardButton) {
          <div style="margin-top: 8px">
            <button
              mat-stroked-button
              color="primary"
              type="button"
              (click)="onVerifyCardClick()"
              style="height: 44px; padding: 0 16px; display: inline-flex; align-items: center; gap: 6px; white-space: nowrap; line-height: normal"
            >
              <mat-icon style="margin: 0; overflow: visible">verified_user</mat-icon>
              <span>Verify Card</span>
            </button>
          </div>
          } }
        </div>
      </fieldset>
      }
      @if (paymentType === 'ACH') {
      <fieldset style="padding: 16px; height: fit-content; align-self: flex-start">
        <legend>Bank Account Information</legend>
        <app-ach-details-form [hideDefaultOption]="true" />
      </fieldset>
      }
    </div>
    <div class="col-sm-6 col-12" style="padding-bottom: 24px" *ngIf="!hideCustomerInfo">
      <fieldset style="min-height: 460px; padding: 16px; @media (max-width: 991px) {min-height: 250px}">
        <legend>Customer Information</legend>
        <div class="form-control-group">
          <div class="form-control" style="min-width: 280px; max-width: 100%" *ngIf="!hideCustomerName">
            <mat-form-field appearance="outline">
              <mat-label>Customer Name</mat-label>
              <input matInput #customerNameInput formControlName="customerName" [readonly]="isViewMode" />
              <mat-error>
                @if (form.controls.customerName.hasError('required')) { Customer name is required. } @if
                (form.controls.customerName.hasError('minlength')) { Name must be at least 2 characters } @if
                (form.controls.customerName.hasError('pattern')) { Only letters, numbers, spaces, hyphens and
                apostrophes allowed } @if (form.controls.customerName.hasError('maxlength')) { Name cannot exceed 50
                characters }
              </mat-error>
            </mat-form-field>
          </div>
        </div>

        <div class="form-control-group">
          <div class="form-control" style="min-width: 280px; max-width: 100%" *ngIf="!hideCustomerName">
            <mat-form-field appearance="outline">
              <mat-label>Customer Reference Number</mat-label>
              <input
                matInput
                #customerReferenceNumberInput
                formControlName="customerReferenceNumber"
                [readonly]="isViewMode"
              />
              <mat-error>
                @if (form.controls.customerReferenceNumber.hasError('maxlength')) { Reference number must be less than
                25 characters } @if (form.controls.customerReferenceNumber.hasError('pattern')) { Only letters, numbers,
                spaces, and hyphens allowed }
              </mat-error>
            </mat-form-field>
          </div>
        </div>
        <div class="form-control">
          <mat-slide-toggle [formControl]="form.controls.saveCustomer" color="primary">
            Save Customer Information
          </mat-slide-toggle>
        </div>
        @if(form.controls.saveCustomer.value) {
        <div class="form-control" style="padding-left: 24px">
          <mat-slide-toggle [formControl]="form.controls.saveToken" color="primary">
            @if (paymentType === 'ACH') { Store account on file } @else { Store card on file }
          </mat-slide-toggle>
        </div>
        }
      </fieldset>
    </div>
  </div>
</div>
